import { render, staticRenderFns } from "./data-center.vue?vue&type=template&id=3d4f297c&scoped=true"
import script from "./data-center.vue?vue&type=script&lang=js"
export * from "./data-center.vue?vue&type=script&lang=js"
import style0 from "./data-center.vue?vue&type=style&index=0&id=3d4f297c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f297c",
  null
  
)

export default component.exports